module.exports = __webpack_public_path__ + "static/media/13.316a4652.png";